import { useNavigate } from "react-router-dom"
import { PlanFeature } from "../../utils/utils"

const BlocLeftImg=()=>{
    const navigate=useNavigate()
    return(
        <div className="box-grey space-bloc">
            <div className="container">
                <div className="row">
                    <div className="col-md-7"><img src="/images/manwithBoard.svg" alt="tableau de borad " className="w-100"/> </div>
                    <div className="col-md-5 d-flex flex-column justify-content-center">
                        <h2 className="grey500">Votre tableau de bord centralisé</h2>
                        <p className="body grey66 mt-16">
                        Accédez à un aperçu global de vos rendez-vous, paiements, et revenus directement depuis votre tableau de bord. Gérez simplement votre activité 
                        avec Twyny, en toute transparence et sérénité.
                        </p>
                        <div className="mt-16"><PlanFeature text="Suivi de votre Chiffre d’Affaires" /></div>
                        <div className="mt-16"><PlanFeature text="Gestion des paiements" /></div>
                        <div className="mt-16"><PlanFeature text="Gestion des avis clients" /></div>
                        <div className="mt-16"><PlanFeature text="Accès à votre agenda connecté" /></div>
                        <button className=" twyny-cta-primary mt-32 fit-content" onClick={()=>navigate('/registerPrestataire')}>
                        Découvrir gratuitement
                        </button>
                    </div>
                </div>
            </div>
            </div>

    )
}
export default BlocLeftImg